const BACKEND_ENV_NAME = (process.env.REACT_APP_BACKEND_ENVIRONMENT_NAME || '').toLowerCase()
const OBJECTIVE_PASTE_ONLY_CREATE = process.env.REACT_APP_OBJECTIVE_PASTE_ONLY_CREATE === 'true'

export interface ObjectiveCreateFlow {
    currentRegion: 'EU' | 'US'
    otherRegion: 'EU' | 'US'
    isPasteOnlyCreate: boolean
}

export const getObjectiveCreateFlow = (
    backendEnvName: string = BACKEND_ENV_NAME,
    pasteOnlyEnabled: boolean = OBJECTIVE_PASTE_ONLY_CREATE,
): ObjectiveCreateFlow => {
    const currentRegion = backendEnvName.toLowerCase() === 'produs' ? 'US' : 'EU'

    return {
        currentRegion,
        otherRegion: currentRegion === 'EU' ? 'US' : 'EU',
        isPasteOnlyCreate: pasteOnlyEnabled && currentRegion === 'US',
    }
}
